import styled from "styled-components";
import { Menu } from "antd";
import { CONTENT_WIDTH, media, PAGE_GUTTER } from "@/theme/breakpoints";

export const MainContainer = styled.div`
  margin: 0 auto;
  margin-top: 22px;
  width: ${CONTENT_WIDTH.pct};
  max-width: 100%;
  box-sizing: border-box;
  overflow-x: hidden;

  ${media.downTablet`
    width: 100%;
    margin-top: 16px;
    padding: 0 ${PAGE_GUTTER.tablet}px;
    overflow-x: hidden;
  `}

  ${media.downMobile`
    padding: 0 ${PAGE_GUTTER.mobile}px;
  `}
`;

export const AccountTitle = styled.h1`
  display: none;
  margin: 0 0 8px;
  color: #111;
  font-family: Poppins, sans-serif;
  font-size: 24px;
  font-weight: 600;
  line-height: 1.2;

  ${media.downTablet`
    display: block;
  `}

  ${media.downMobile`
    font-size: 22px;
  `}
`;

export const NavSectionLabel = styled.p`
  display: none;
  margin: 0 0 10px;
  color: #6b7280;
  font-family: Poppins, sans-serif;
  font-size: 13px;
  font-weight: 500;
  letter-spacing: 0.02em;
  text-transform: uppercase;

  ${media.downTablet`
    display: block;
  `}
`;

export const InnerContainer = styled.div`
  display: flex;
  gap: 3%;
  max-width: 100%;
  min-width: 0;

  ${media.downTablet`
    gap: 20px;
    flex-direction: column;
    width: 100%;
  `}
`;

export const LeftCol = styled.div`
  flex: 0 0 auto;
  min-width: 0;
  max-width: 100%;

  ${media.upDesktop`
    min-width: 300px;
    width: max-content;
    overflow: visible;
  `}

  ${media.downTablet`
    margin-bottom: 0;
    overflow: hidden;
  `}
`;

export const RightCol = styled.div`
  flex: 1;
  min-width: 0;
  max-width: 100%;
  overflow-x: hidden;

  ${media.downTablet`
    padding-top: 4px;
    border-top: 1px solid #e5e7eb;
  `}
`;

export const MenuScrollWrap = styled.div`
  max-width: 100%;
  min-width: 0;

  ${media.upDesktop`
    overflow: visible;
  `}

  ${media.downTablet`
    width: 100%;
    overflow-x: hidden;
  `}
`;

export const StyledMenu = styled(Menu)`
  border-inline-end: unset !important;
  max-width: 100%;
  min-width: 0;
  box-sizing: border-box;

  ${media.upDesktop`
    width: max-content;
    min-width: 300px;

    .ant-menu-item {
      overflow: visible;
      white-space: nowrap;
    }

    .ant-menu-item > .ant-menu-title-content {
      overflow: visible;
      text-overflow: unset;
      white-space: nowrap;
    }
  `}

  .ant-menu-item {
    margin-bottom: 10px;
    color: #000;
    text-align: center;
    font-family: Poppins;
    font-size: 20px;
    font-style: normal;
    font-weight: 600;
    line-height: 120%;
    text-transform: capitalize;
  }
  .ant-menu-item-selected {
    background-color: #f5f5f5;
    color: #ed6928;
  }
  .ant-menu-item > .ant-menu-title-content {
    text-align: left;
    padding-left: 6px;
  }

  ${media.downTablet`
    display: block !important;
    width: 100% !important;
    min-width: 0 !important;
    max-width: 100% !important;
    border-inline-end: none !important;
    background: #f9fafb;
    border: 1px solid #e5e7eb;
    border-radius: 10px;
    padding: 8px !important;

    &.ant-menu,
    .ant-menu-root,
    ul.ant-menu {
      width: 100% !important;
      max-width: 100% !important;
      min-width: 0 !important;
    }

    .ant-menu-item {
      display: flex !important;
      align-items: center;
      width: 100% !important;
      max-width: 100% !important;
      height: auto !important;
      min-height: 48px;
      margin: 4px 0 !important;
      padding: 12px 14px !important;
      white-space: normal;
      border-radius: 8px;
      font-size: 15px;
      line-height: 1.35;
      box-sizing: border-box;
      overflow: hidden;
    }

    .ant-menu-item-selected {
      background-color: #fff7f2 !important;
      color: #ed6928;
      box-shadow: inset 3px 0 0 #ed6928;
    }

    .ant-menu-item > .ant-menu-title-content {
      flex: 1;
      min-width: 0;
      padding-left: 10px;
      overflow-wrap: anywhere;
      word-break: break-word;
    }

    .ant-menu-item .anticon,
    .ant-menu-item .ant-menu-item-icon {
      flex-shrink: 0;
    }
  `}

  ${media.downMobile`
    .ant-menu-item {
      font-size: 14px;
      min-height: 44px;
      padding: 10px 12px !important;
    }
  `}
`;
